import {clamp, round, roundToZero} from '@benchling/js-utils';

import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import {MAX_PRECISION} from 'notebook/tables/excess/Util';

export default {
  name: 'ROUND',
  category: FunctionCategory.MATH,
  shortDescription: 'Rounds a number to a number of decimal places.',
  description: 'Rounds a number to a certain number of decimal places according to standard rules.',
  params: [
    {
      name: 'value',
      type: ArgType.number,
      description: 'The value to round to num_places number of places.',
    },
    {
      name: 'num_places',
      type: ArgType.number,
      description: 'The number of decimal places to which to round.',
    },
  ],
  eval: (value: number, numDigits: number): number => {
    const intNumDigits = clamp(-MAX_PRECISION, MAX_PRECISION, roundToZero(numDigits));
    return round(value, intNumDigits);
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
